// JavaScriptモジュール
import uajs from './modules/ua.js';
(function(_exports, $) {
	const break_point = 900;

const setToggleNavMain = () => {
	const nav_main = $(".nav-main"),
		btn_open = $('.button--toggle'),
		btn_close = $('.button--nav-close'),
		shadow = nav_main.find(".shadow"),
		fade_time = 400
		;


	btn_open.on("click", function(e) {
		e.preventDefault();

		nav_main.addClass("is-open");
		shadow.fadeIn( fade_time );
		btn_close.fadeIn( fade_time );
	})

	btn_close.on("click", function(e) {
		e.preventDefault();

		nav_main.removeClass("is-open");
		shadow.fadeOut( fade_time );
		btn_close.fadeOut( fade_time );
	});

	shadow.on("click", function(e) {
		nav_main.removeClass("is-open");
		shadow.fadeOut( fade_time );
		btn_close.fadeOut( fade_time );
	});
};

const setWave = () => {


	if ( $(window).outerWidth() > break_point ) {

		if ( $("#wave1").length > 0 ) {
			$("#wave1").wavify({
				height: 60,
				bones: 3,
				amplitude: 40,
				color: '#fff',
				speed: .25
			});
		}

		if ( $("#wave2").length > 0 ) {
			$("#wave2").wavify({
				height: 60,
				bones: 3,
				amplitude: 40,
				color: '#fff',
				speed: .25
			});
		}

		if ( $("#wave-footer").length > 0 ) {
			$("#wave-footer").wavify({
				height: 60,
				bones: 3,
				amplitude: 40,
				color: '#e8f8fa',
				speed: .25
			});
		}
	} else {

		if ( $("#wave1").length > 0 ) {
			$("#wave1").wavify({
				height: 30,
				bones: 3,
				amplitude: 15,
				color: '#fff',
				speed: .25
			});
		}

		if ( $("#wave2").length > 0 ) {
			$("#wave2").wavify({
				height: 30,
				bones: 3,
				amplitude: 15,
				color: '#fff',
				speed: .25
			});
		}

		if ( $("#wave-footer").length > 0 ) {
			$("#wave-footer").wavify({
				height: 30,
				bones: 3,
				amplitude: 15,
				color: '#e8f8fa',
				speed: .25
			});
		}
	}
};

const fadeSNSBlock = () => {
	if ( $(window).outerWidth() > break_point ) {

		const target = $(".js-sns-side"),
			fade_time = 400
			;

		let limit_height = 900
			;

		if ( target.length > 0 ) {

			$(window).on("scroll", function(){
				const scroll_top = $(window).scrollTop()
				;

				if ( scroll_top > limit_height ) {
					target.fadeOut( fade_time );
				} else {
					target.fadeIn( fade_time );
				}
			});
		}
	}
};

const setMainSlider = () => {
	if ( $("body.home").length > 0 && $(".js-main-slider").length > 0 ) {
		const target = $(".js-main-slider")
			;

		target.slick({
			slidesToShow: 1,
			slidesToScroll: 1,
			arrows: false,
			fade: true,
			autoplay: true,
			autoplaySpeed: 7000,
			pauseOnHover: false
		});

	}
};


$(document).ready(function () {
	let ua = uajs()

	if(!ua.Mobile){
	    $('a[href^="tel:"]').addClass('reset-a-style').on('click', function(e) {
	        e.preventDefault();
	    });
	}

	if($(window).width() >= 720) {
		$('meta[name="viewport"]').attr('content', 'width=1360');
	}

	$("a[href^='#']").not(".no-scroll").click( function (e) {
		let href = $(this).attr('href');
		if(href.match(/^#/) && $(href).length > 0) {
			e.preventDefault()
			$('html, body').animate({ scrollTop: $(href).offset().top }, 'fast')
		}
	})

	setToggleNavMain();
	setWave();
	fadeSNSBlock();
	setMainSlider();
})

})(typeof window !== "undefined" ? window : this, window.jQuery );